import { useState } from "react";
import AILearning from "./AILearning";
import ResumeOptimizer from "./ResumeOptimizer";
import TextSoul from "./TextSoul";

/* ════════════════════════════════════════════
   STYLES
════════════════════════════════════════════ */
const NavStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,700;9..144,900&family=DM+Sans:wght@400;500;600;700&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'DM Sans', sans-serif; }

    .nav-bar {
      position: fixed; top: 0; left: 0; right: 0; z-index: 9999;
      height: 52px;
      background: rgba(15, 15, 20, 0.92);
      backdrop-filter: blur(12px);
      border-bottom: 1px solid rgba(255,255,255,0.06);
      display: flex; align-items: center; padding: 0 20px; gap: 0;
    }
    .nav-logo {
      font-family: 'Fraunces', serif;
      font-weight: 900; font-size: 16px;
      background: linear-gradient(135deg, #10b981, #38bdf8);
      -webkit-background-clip: text; -webkit-text-fill-color: transparent;
      margin-right: 32px; letter-spacing: -0.3px; white-space: nowrap;
      cursor: pointer;
    }
    .nav-tabs { display: flex; gap: 2px; flex: 1; }
    .nav-tab {
      padding: 6px 16px; border-radius: 8px; font-size: 13px; font-weight: 600;
      cursor: pointer; color: rgba(255,255,255,0.45); border: none; background: transparent;
      transition: all .15s; font-family: 'DM Sans', sans-serif; white-space: nowrap;
    }
    .nav-tab:hover { color: rgba(255,255,255,0.8); background: rgba(255,255,255,0.05); }
    .nav-tab.on { color: #fff; background: rgba(255,255,255,0.1); }
    .nav-tab.on.green  { background: rgba(16,185,129,0.2); color: #10b981; }
    .nav-tab.on.amber  { background: rgba(245,158,11,0.2); color: #f59e0b; }
    .nav-tab.on.sky    { background: rgba(56,189,248,0.2); color: #38bdf8; }

    .tool-content { padding-top: 52px; min-height: 100vh; }

    /* ── Home page ── */
    .home-page {
      min-height: 100vh; background: #0a0a0f;
      display: flex; flex-direction: column; align-items: center;
      padding: 80px 24px 60px;
    }
    .home-headline {
      font-family: 'Fraunces', serif; font-weight: 900; font-size: 48px;
      color: #fff; text-align: center; line-height: 1.15; letter-spacing: -1.5px;
      margin-bottom: 16px; max-width: 680px;
    }
    .home-headline span {
      background: linear-gradient(135deg, #10b981, #38bdf8);
      -webkit-background-clip: text; -webkit-text-fill-color: transparent;
    }
    .home-sub { font-size: 16px; color: rgba(255,255,255,0.45); text-align: center; margin-bottom: 64px; max-width: 480px; line-height: 1.7; }

    .home-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; max-width: 860px; width: 100%; }
    @media (max-width: 700px) { .home-grid { grid-template-columns: 1fr; } .home-headline { font-size: 32px; } }

    .tool-card {
      background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08);
      border-radius: 20px; padding: 28px 24px; cursor: pointer;
      transition: all .2s; position: relative; overflow: hidden;
    }
    .tool-card::before {
      content: ''; position: absolute; inset: 0; opacity: 0; transition: opacity .2s;
      border-radius: inherit;
    }
    .tool-card.green::before { background: radial-gradient(circle at 50% 0%, rgba(16,185,129,0.12), transparent 60%); }
    .tool-card.amber::before { background: radial-gradient(circle at 50% 0%, rgba(245,158,11,0.12), transparent 60%); }
    .tool-card.sky::before   { background: radial-gradient(circle at 50% 0%, rgba(56,189,248,0.12), transparent 60%); }
    .tool-card:hover { border-color: rgba(255,255,255,0.2); transform: translateY(-3px); box-shadow: 0 20px 60px rgba(0,0,0,0.4); }
    .tool-card:hover::before { opacity: 1; }
    .tool-card.green:hover { border-color: rgba(16,185,129,0.4); }
    .tool-card.amber:hover { border-color: rgba(245,158,11,0.4); }
    .tool-card.sky:hover   { border-color: rgba(56,189,248,0.4); }

    .tc-icon { font-size: 36px; margin-bottom: 14px; display: block; }
    .tc-name { font-size: 18px; font-weight: 700; color: #fff; margin-bottom: 6px; }
    .tc-desc { font-size: 13px; color: rgba(255,255,255,0.45); line-height: 1.65; margin-bottom: 18px; }
    .tc-tags { display: flex; flex-wrap: wrap; gap: 5px; margin-bottom: 18px; }
    .tc-tag  { padding: 2px 9px; border-radius: 20px; font-size: 10px; font-weight: 700; letter-spacing: .3px; }
    .tc-btn  {
      width: 100%; padding: 9px; border-radius: 10px; font-size: 13px; font-weight: 700;
      cursor: pointer; border: none; font-family: 'DM Sans', sans-serif; transition: all .15s;
    }
    .tc-btn.green { background: rgba(16,185,129,0.15); color: #10b981; border: 1px solid rgba(16,185,129,0.3); }
    .tc-btn.green:hover { background: #10b981; color: #fff; }
    .tc-btn.amber { background: rgba(245,158,11,0.15); color: #f59e0b; border: 1px solid rgba(245,158,11,0.3); }
    .tc-btn.amber:hover { background: #f59e0b; color: #fff; }
    .tc-btn.sky { background: rgba(56,189,248,0.15); color: #38bdf8; border: 1px solid rgba(56,189,248,0.3); }
    .tc-btn.sky:hover { background: #38bdf8; color: #fff; }

    .home-footer { margin-top: 64px; font-size: 12px; color: rgba(255,255,255,0.2); text-align: center; }

    @keyframes homeIn { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
    .home-page > * { animation: homeIn .5s ease both; }
    .home-page > *:nth-child(2) { animation-delay: .08s; }
    .home-page > *:nth-child(3) { animation-delay: .15s; }
    .home-page > *:nth-child(4) { animation-delay: .22s; }
  `}</style>
);

/* ════════════════════════════════════════════
   HOME PAGE
════════════════════════════════════════════ */
const TOOLS = [
  {
    id: "learning",
    color: "green",
    icon: "🧠",
    name: "AI 学习课程",
    desc: "30天系统学习 AI 实战应用，每日课程、实操练习、打卡签到",
    tags: [["AI大模型","#10b981"],["30天课程","#10b981"],["密钥解锁","#f59e0b"]],
    features: ["30天完整课程体系","国内+国际双栏资源","AI打卡评分系统"],
  },
  {
    id: "resume",
    color: "amber",
    icon: "📄",
    name: "AI 简历优化",
    desc: "上传简历自动解析，AI 优化语言、强化成果、岗位关键词匹配",
    tags: [["PDF/Word上传","#f59e0b"],["STAR法则","#f59e0b"],["岗位匹配","#38bdf8"]],
    features: ["智能简历解析","3种优化模式","一键导出PDF"],
  },
  {
    id: "textsoul",
    color: "sky",
    icon: "✍️",
    name: "TextSoul 去AI化",
    desc: "剔除机器味，对抗循环重写，让AI文案通过检测并恢复真实人味",
    tags: [["对抗循环","#38bdf8"],["4种风格","#38bdf8"],["小红书/知乎","#a78bfa"]],
    features: ["最多3轮对抗循环","AI痕迹实时检测","词汇前后对比"],
  },
];

function HomePage({ onSelect }) {
  return (
    <div className="home-page">
      <h1 className="home-headline">
        三大 <span>AI 工具</span>，<br/>一个平台搞定
      </h1>
      <p className="home-sub">
        学 AI · 优化简历 · 去AI化文案<br/>
        全部免费使用，无需注册
      </p>

      <div className="home-grid">
        {TOOLS.map(t => (
          <div key={t.id} className={`tool-card ${t.color}`} onClick={() => onSelect(t.id)}>
            <span className="tc-icon">{t.icon}</span>
            <div className="tc-name">{t.name}</div>
            <div className="tc-desc">{t.desc}</div>
            <div className="tc-tags">
              {t.tags.map(([tag, c]) => (
                <span key={tag} className="tc-tag" style={{ background: c+"18", color: c, border: `1px solid ${c}40` }}>{tag}</span>
              ))}
            </div>
            <div style={{ marginBottom: 18 }}>
              {t.features.map(f => (
                <div key={f} style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginBottom: 4, display:"flex", gap:6, alignItems:"center" }}>
                  <span style={{ color: t.color === "green" ? "#10b981" : t.color === "amber" ? "#f59e0b" : "#38bdf8" }}>›</span>{f}
                </div>
              ))}
            </div>
            <button className={`tc-btn ${t.color}`} onClick={e => { e.stopPropagation(); onSelect(t.id); }}>
              立即使用 →
            </button>
          </div>
        ))}
      </div>

      <div className="home-footer">
        Powered by Claude AI · 数据不会被储存 · API Key 存储在服务端
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════
   MAIN APP
════════════════════════════════════════════ */
export default function App() {
  const [page, setPage] = useState("home"); // home | learning | resume | textsoul

  return (
    <>
      <NavStyles />

      {/* ── Top Navigation Bar ── */}
      <nav className="nav-bar">
        <div className="nav-logo" onClick={() => setPage("home")}>
          ToolKit AI
        </div>
        <div className="nav-tabs">
          {TOOLS.map(t => (
            <button
              key={t.id}
              className={`nav-tab ${page === t.id ? `on ${t.color}` : ""}`}
              onClick={() => setPage(t.id)}
            >
              {t.icon} {t.name}
            </button>
          ))}
        </div>
      </nav>

      {/* ── Page Content ── */}
      <div className="tool-content">
        {page === "home"      && <HomePage onSelect={setPage} />}
        {page === "learning"  && <AILearning />}
        {page === "resume"    && <ResumeOptimizer />}
        {page === "textsoul"  && <TextSoul />}
      </div>
    </>
  );
}
